import { useMutation } from "@tanstack/react-query";
import { paymentService } from "@/services/paymentService";
import { enterpriseService } from "@/services/enterpriseService";

export function useCheckout(options = {}) {
  return useMutation({ mutationFn: paymentService.checkout, ...options });
}

export function useEnterpriseContact(options = {}) {
  return useMutation({ mutationFn: enterpriseService.contact, ...options });
}
